<template>
  <div>
    <div class="sys-sign-out">
      <a-dropdown>
        <div class="user-name">
          <span class="user-avatar">
            <img :src="userIcon" class="user-avatar-img" alt="" />
          </span>
          <span class="user-text">{{ username }}</span>
          <svg class="user-caret" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4.5 6.25 8 9.75l3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <!-- v-if="this.canOperate(['ChangingPassword'])" -->
        <a-menu slot="overlay">
          <a-menu-item  v-if="appId === '10016'">
            <div @click="toIndividualCenter">个人中心</div>
          </a-menu-item>
          <!-- <a-menu-item  v-if="whetherAccountExists == '1'">
            <div @click="changePW">{{ psdType != 2 ? '修改密码' : '设置账号及密码' }}</div>
          </a-menu-item> -->
          <a-menu-item  v-if="logoUi.productRecommendUrl">
            <div @click="goRecommend">关于我们</div>
          </a-menu-item>
          <a-menu-item>
            <div @click="toSignOut">退出</div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <ChangePassword v-model="changePWModal" />
    <InitializeAccount v-model="initModal" />
  </div>
</template>

<script>
import { post } from '@/utils/http';
import { getLogo } from '@/utils/intConfiguration';
import api from '@/api';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
import { pointTools } from '@/utils/point';
import { canOperate } from '@/utils/utils';
import { logoutWithRedirect } from '@/utils/logout';
import ChangePassword from './ChangePassword.vue';
import InitializeAccount from './InitializeAccount.vue'
export default {
  components: {
    ChangePassword,
    InitializeAccount,
  },
  data() {
    return {
      appId: localStorage.getItem('appId') || '',
      logoUi: getLogo(),
      userIcon: require('@/assets/images/pageTabUser.png'),
      username: '',
      changePWModal: false,
      initModal: false,
      psdType: 0, // 2 -设置账号密码 1&0-修改密码
      whetherAccountExists: localStorage.getItem('whetherAccountExists') || '0'
    };
  },
  created() {
    this.username = localStorage.getItem('name') || '众能联合';
  },
  mounted() {
    this.initPsw();
  },
  methods: {
    initPsw() {
      if(this.whetherAccountExists != '1'){
        return;
      }
      if (isCustomerSaasPrivate()) {
        return;
      }
      post(api.queryAccountStatus, {})
      .then(res=> {
        this.psdType = res;
      })
    },
    canOperate(codes) {
      return canOperate(codes);
    },
    // 修改密码
    changePW() {
      this.psdType != 2 ? this.changePWModal = true : this.initModal = true;
    },
    // 退出
    async toSignOut() {
      this.traceSignOut();
      const { redirected } = await logoutWithRedirect({
        router: this.$router,
        routePath: this.$route.path,
      });
      if (!redirected) {
        this.reloadByAppId();
      }
    },
    traceSignOut() {
      pointTools.traceClick({
        event_type: 'web_click',
        content: {
          event_id: 'page_ext',
          event_name: '退出登录',
        },
      });
    },
    // 判断appId
    reloadByAppId() {
      const appId = localStorage.getItem('appId');
      if (appId === '90001' || appId === '20001' || appId === '10004' || appId === '10009' || appId === '20004' || appId === '20008') {
        window.location.reload();
      }
    },
    goRecommend() {
      this.$router.push('/recommend');
    },
    toIndividualCenter() {
      this.$router.push('/IndividualCenter');
    }
  },
};
</script>
<style lang="less" scoped>
.sys-sign-out {
  .user-name {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 36px;
    cursor: pointer;
    font-size: 14px;
    color: #222222;

    .user-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      flex-shrink: 0;

      .user-avatar-img {
        width: 28px;
        height: 28px;
        object-fit: contain;
      }
    }

    .user-caret {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
      color: #222222;
    }
  }
}
</style>
